import React from 'react';

import { VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceStart } from '@confluence/experience-tracker/entry-points/component.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';

import type { RestrictionsDialogTriggerProps } from '../types.ts';

import { RestrictionsDialogTrigger } from './RestrictionsDialogTrigger.tsx';

export const RestrictionsDialogTriggerWrapper = (props: RestrictionsDialogTriggerProps): React.JSX.Element => {
	const { accessStatus } = useSessionData();

	const hasAccess =
		accessStatus === AccessStatus.LICENSED_USE_ACCESS ||
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;

	return (
		<ErrorBoundary
			attribution={Attribution.PERMISSIONS_EXPERIENCE}
			key="restrictions-dialog-trigger"
		>
			{hasAccess ? (
				<>
					<ExperienceStart
						key="restriction-button-start"
						id={props.contentId}
						name={VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE}
					/>
					<RestrictionsDialogTrigger {...props} />
				</>
			) : null}
		</ErrorBoundary>
	);
};
